import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { ConfigService } from '../_services/config.service';
import { ApiService } from '../_services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ExportComponent } from '../export/export.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'true-insights',
  templateUrl: './insights.component.html',
  styleUrl: './insights.component.scss',
  standalone: false
})
export class InsightsComponent {
  assessmentName: string = "/";
  assessmentObject: string = "";
  recommendationsLoading = false;
  assessment = {};
  assessmentId;

  commentsList: { title: string; text: string }[] = [
    { title: 'Enter information to receive insightful comments', text: 'Your input helps us provide tailored feedback.' }
  ];
  
  recommendationsList: { title: string; text: string }[] = [
    { title: 'Provide more details to unlock personalized recommendations', text: 'Your data drives meaningful insights.' }
  ];
  
  constructor(private router: Router, protected api: ApiService, public readonly config: ConfigService, private dialog: MatDialog,) { }
  
  ngOnInit(): void {
    this.api.getAssessment().subscribe((assessment) => {      
      if (assessment) {
        this.assessment = assessment;
        this.assessmentId = assessment.id;
        this.assessmentName = assessment.name;
        this.assessmentObject = assessment.object;
        console.log(assessment);
      }
    });
  }

  getFeedback(): void {
    this.commentsList = [];
    this.recommendationsList = [];
    this.getSustainabilityFeedback();
    this.getLLMFeedback ();    
  }

  getSustainabilityFeedback(): void {
    const nodePillarMap: Record<string, number> = {
      RadiantMarketAndRetailers: 1,
      RadiantProcessing: 2,
      RadiantProduction: 3,
      RadiantTransportAndDistribution: 4,
    };
  
    const enabledKeys = this.getEnabledNodeKeys(this.assessment);
    const displayNames: string[] = [];
    let pending = enabledKeys.length;
    let anyIncomplete = false;
  
    enabledKeys.forEach(key => {
      const displayName = key
        .replace(/^Radiant/, '')
        .replace(/([a-z])([A-Z])/g, '$1 $2');
  
      const pillarId = nodePillarMap[key];
      if (!pillarId) return;
  
      this.getPillarStats(pillarId).subscribe(stats => {
        const entry = `${displayName} (${stats.answered}/${stats.total})`;
        displayNames.push(entry);
  
        if (stats.answered < stats.total) {
          anyIncomplete = true;
        }
  
        pending--;
        if (pending === 0) {
          const nodeText = displayNames.length === 1
            ? displayNames[0]
            : displayNames.slice(0, -1).join(', ') + ' and ' + displayNames.slice(-1);
  
          this.commentsList.push({
            title: 'Sustainability assessment',
            text: `You are assessing the sustainability of the following node${displayNames.length > 1 ? 's' : ''}: ${nodeText}.`
          });
  
          if (anyIncomplete) {
            this.recommendationsList.push({
              title: 'Sustainability assessment',
              text: 'Adding more data leads to a clearer sustainability score and greater confidence in its accuracy.'
            });
          }
        }
      });
    });
  }

  getPillarStats(pillarId: number): Observable<{ answered: number; total: number }> {
    return this.api.getUserPillarIndicators(this.assessmentId, pillarId).pipe(
      map(indicators => {
        console.log(indicators);
        const total = indicators.length;
        const answered = indicators.filter(ind => ind.Assessment_indicator_answers.length > 0).length;
        return { answered, total };
      })
    );
  }

  getEnabledNodeKeys(assessment: any): string[] {
    return assessment?.nodes
      ?.filter(node => node.enabled)
      .map(node =>
        node.key          
      ) || [];
  }

  getLLMFeedback (): void {
    // Add LLM feedback    
    this.recommendationsLoading = true;    
      this.api.getAssessmentQuestionnaires().subscribe((questionnaires) => {      
        //using brief templateId for now            
        const qId = questionnaires.find(q => q.template.id === 2 || q.template.id === 3).id;
        try {
          this.api.getQuestionnaireRecommendation(qId).subscribe((feedback) => {      
            console.log("Got LLM feedback!");
            console.log(feedback);
            this.parseCommentsAndRecommendations(feedback);
            this.recommendationsLoading = false;
          });
        } catch (e) {
          console.log('Get LLM feedback server error: ', e)
          this.recommendationsLoading = false;
        }
      });    
  }

  parseCommentsAndRecommendations(feedback: any): void {
    let parsed;  
    try {
      parsed = typeof feedback === 'string' ? JSON.parse(feedback) : feedback;
    } catch (e) {
      console.error('Failed to parse feedback JSON:', e);
      this.commentsList = [{ title: 'Error', text: 'Could not parse feedback.' }];
      this.recommendationsList = [];
      return;
    }
  
    const isValidFormat = parsed &&
      Array.isArray(parsed.comments) &&
      Array.isArray(parsed.recommendations) &&
      parsed.comments.every(c => c.title && c.text) &&
      parsed.recommendations.every(r => r.title && r.text);
  
    if (!isValidFormat) {
      this.commentsList = [{ title: 'Wrong format', text: '' }];
      this.recommendationsList = [{ title: 'Raw JSON', text: JSON.stringify(parsed, null, 2) }];
      return;
    }
  
    this.commentsList.push(...parsed.comments);    
    this.recommendationsList.push(...parsed.recommendations);
  }

  navigate(id): void {
    this.router.navigate(['/'+id]);    
  }

  sendForReview(): void {    
    let dialogRef = this.dialog.open(ExportComponent, {
      height: '400px',
      width: '600px',
    });
  }

}
